enum Endpoint {
  HealthCheck = '/',
  // Auth
  AuthLogin = '/auth/login',
  AuthLogout = '/auth/logout',
  AuthResetPassword = '/auth/password/reset',
  AuthUpdatePasswordWithToken = '/auth/password/update_with_token',
  AuthSignup = '/auth/signup',
  AuthFromMagicLinkToken = '/auth/fromMagicLinkToken',
  StartEmailOTP = '/auth/otp/email/start',
  StartPhoneOTP = '/auth/otp/phone/start',
  CompleteEmailOTP = '/auth/otp/email/complete',
  CompletePhoneOTP = '/auth/otp/phone/complete',
  FinishEmailOTPSignup = '/auth/otp/email/finishSignup',
  FinishPhoneOTPSignup = '/auth/otp/phone/finishSignup',
  FinishOAuthSignup = '/auth/oauth/finishSignup',
  OAuthLoginOrStartSignup = '/auth/oauth/web/loginOrStartSignup',
  // Users
  UsersGetInfo = '/users/getInfo',
  UsersCreateSupportTicket = '/users/createSupportTicket',
  UsersGetUser = '/users/getProfile',
  // User info
  UserUpdateUnverifiedAuthorityIdentifier = '/userInfo/updateUnverifiedAuthorityIdentifier',
  // Impressions
  UserImpressionSave = '/userImpression/save',
  // Loads
  LoadsSearchV2Ungrouped = '/loads/searchV2Ungrouped',
  LoadsSearchCount = '/loads/searchCount',
  LoadsRefreshSearchV2Ungrouped = '/loads/refreshSearchV2Ungrouped',
  PublicSearchLoadsByBroker = '/loads/publicSearchLoadsByBroker',
  LoadsGet = '/loads/get',
  LoadsGetPublic = '/loads/getPublic',
  LoadsGetRoutePolyline = '/loads/getRoutePolyline',
  LoadsExtractUserView = '/loads/extractUserView',
  LoadsGetReloadsDataByDestination = '/loads/getReloadsDataByDestination',
  LoadsGetRecommendedSortWeightMap = '/loads/getRecommendedSortWeightMap',
  // Location
  LocationGetLocations = '/location/getLocations',
  LocationGetLocationDetails = '/location/getLocationDetails',
  LocationGetAddresses = '/location/getAddresses',
  // Broker Directory
  BrokersGet = '/brokers/getAll',
  BrokersGetByIds = '/brokers/getByIds',
  BrokerDirectoryGetAll = '/brokersSearch/getAll',
  BrokerDirectoryGetBrokerById = '/brokersSearch/get',
  BrokerDirectoryRequestBroker = '/factoringBrokers/requestBroker',

  // Broker Accounts
  BrokerAccountsGet = '/brokerAccounts/getAllBrokerCredentials',
  BrokerAccountsAdd = '/brokerAccounts/upsertBrokerCredentialV2',
  BrokerAccountsRemove = '/brokerAccounts/deleteBrokerCredential',
  BrokerAccountsVerifyOTP = '/brokerAccounts/verifyOTP',
  BrokerAccountsValidatePassword = '/brokerAccounts/validatePassword',
  BrokerAccountsSelectOTPContact = '/brokerAccounts/selectOTPContact',
  BrokerAccountsDiscoverBrokerAccounts = '/brokerAccounts/discoverBrokerAccounts',
  BrokerAccountsConnectDiscoveredAccounts = '/brokerAccounts/connectDiscoveredAccounts',
  // Booking
  BookNow = '/booking/bookNow',
  GetBookingStatus = 'booking/getBookingStatus',
  // Booked Loads
  BookedLoadsGetActive = '/bookedLoads/getActive',
  BookedLoadsGetDelivered = '/bookedLoads/getDelivered',
  BookedLoadsUpdate = '/bookedLoads/update',
  // Bidding
  BidsCreate = '/bids/create',
  BidsUpdateBidActivities = '/bidActivities/update',
  BidsGetBidActivities = '/bidActivities/get',
  BidsUpdateBidActivityForLoad = '/bidActivities/updateForLoad',
  BidsMarkBidActivityAsLoadUnavailable = '/bidActivities/markAsLoadUnavailable',
  BidsAcceptOffer = '/bids/acceptOffer',
  BidsEditBid = '/bids/editBid',
  BidsGetCurrentBidActivityForLoad = '/bidActivities/getCurrentActivityForLoad',
  // Carrier Verification
  CarrierVerificationGetInfo = '/carrierVerificationRequests/getCarrierVerificationInfo',
  CarrierVerificationCreateVerifiedCarrier = '/carrierVerificationRequests/createAndSetValidatedCarrierForUser',
  // Broker Carrier
  ExtractDrivers = '/brokerCarrier/extractDrivers',
  GetValidBrokerCarriers = '/brokerCarrier/getValidBrokerCarrierInfo',
  // User Recent Loads
  RecordUserRecentLoad = '/userRecentLoads/record',
  GetRecentLoadsForUser = '/userRecentLoads/getAll',
  GetIsLoadSavedForUser = '/userRecentLoads/isSaved',
  UnsaveLoad = '/userRecentLoads/unsave',

  // Banking
  VerifyBankingOTPCode = '/banking/verifyOTPCode',
  SendBankingOtpCode = '/banking/sendOTPCode',
  BankingListTaxForms = '/banking/listTaxForms',
  BankingFetchTaxFormPdfById = '/banking/getTaxFormPdfById',
  BankingGetUserBankingAccountNumbers = '/banking/accounts/getBankingAccountNumbers',

  // Factoring
  FactoringGetExistingContract = '/factoringOnboarding/getUserExistingContractRecord',
  FactoringAddUserExistingContract = '/factoringOnboarding/addUserExistingContract',
  FactoringGetAllFactoringCompanies = '/factoringCompanies/getAllFactoringCompanies',
  FactoringGetFSASigningLink = '/factoringOnboarding/getFSAWithPersonalGuaranteeSigningLink',
  FactoringGetOnboarding = '/factoringOnboarding/getOnboarding',
  CreateFactoringOnboarding = '/factoringOnboarding/createOnboarding',
  FactoringOnboardingLandingPromotionDetails = '/factoringOnboarding/getActiveFactoringOnboardingPromotionAttributes',
  CreateIndividualBankApplication = '/factoringOnboarding/createIndividualBankApplication',
  CreateBusinessBankApplication = '/factoringOnboarding/createBusinessBankApplication',
  GetExistingContract = '/factoringOnboarding/getUserExistingContract',
  SendBuyoutNoticeEmailTemplate = '/factoringExistingContracts/sendBuyoutNoticeEmailTemplate',
  FetchFrontendCarrierAndSaveHighwayCarrierDataByMcOrDot = '/highwayCarrierData/fetchFrontendCarrierAndSaveHighwayCarrierDataByMcOrDot',
  FactoringGetInvoice = '/factoringInvoices/get',
  FactoringGetAllInvoices = '/factoringInvoices/getAll',
  FactoringInvoiceCreateSupportTicket = '/factoringInvoices/createInvoiceSupportTicket',
  FactoringInvoiceGetPriorityPaymentOffer = '/factoringInvoices/getPriorityPaymentOffer',
  FactoringInvoiceCreate = '/factoringInvoices/create',
  FactoringInvoiceUpdate = '/factoringInvoices/update',
  FactoringInvoiceSubmit = '/factoringInvoices/submit',
  FactoringInvoiceBillbackUserCard = '/factoringInvoiceBillbacks/billbackUserCard',
  FactoringFilterAndPaginateInvoices = '/factoringInvoices/filterAndPaginateInvoices',
  FactoringGetBrokerIdsWithSubmittedInvoices = '/factoringInvoices/getBrokersWithSubmittedInvoices',
  FactoringGetInvoicesThatNeedReviewSearchQuery = '/factoringInvoices/getNeedReviewSearchQuery',
  FactoringGetInvoiceListCSVDownloadUrl = '/factoringInvoices/getInvoiceListCSVDownloadUrl',
  FactoringGetInvoicesAgingReportCSVDownloadUrl = '/factoringInvoices/getAgingReportCSVDownloadUrl',

  // Factoring Broker Assignments
  FactoringBrokerAssignmentsGetBrokerNOAStatus = '/factoringBrokerAssignments/getBrokerNOAStatus',
  FactoringBrokerAssignmentsGetBrokersNOAStatus = '/factoringBrokerAssignments/getBrokersNOAStatus',
  FactoringBrokerAssignmentsSendNoaToBrokerForCarrierUser = '/factoringBrokerAssignments/sendNoaToBrokerForCarrierUser',
  FactoringBrokerAssignmentsRequestManualBrokerNoaSend = '/factoringBrokerAssignments/requestManualBrokerNoaSend',

  //Broker Portal
  AuthBrokerSignup = '/auth/signupBrokerUser',
  BrokerUserSignupAlert = '/brokers/alertBrokerUserSignup',
  brokerUserApiIntegrationRequestAlert = '/brokers/alertBrokerUserApiRequest',
  UpsertTmsAccount = '/tmsAccounts/upsertTmsAccount',
  GetTmsAccount = '/tmsAccounts/getTmsAccount',
  GetTmsBrokerInfo = '/tmsAccounts/getTmsBrokerInfo',
  GetBrokerAndUserAssociation = '/users/getBrokerAndUserAssociation',
  GetAvailableLoadsByBroker = '/loads/getAvailableLoadsByBroker',
  ExtractTmsLoadsForBroker = '/loads/extractTmsLoadsForBroker',
  GetLoadForBroker = '/loads/getLoadForBroker',
  GetLoadForAscendBroker = '/loads/getLoadForAscendBroker',
  RemoveLoadsCsv = '/loads/postings/remove/csv',
  PostManualLoad = '/loads/postings/post/manual',
  BrokerPostCsvAlert = '/brokers/alertBrokerUserTryToPostLoads',
  CreateBrokerUserSupportTicket = '/brokers/createBrokerUserSupportTicket',

  // Fuel
  FuelPartnerTruckStopsGetAllV2 = '/truckStops/getAllV2',
  FuelRoutePolylineGet = '/routePolyline/get',

  // Payment methods
  PaymentMethodsList = '/paymentsMethods/list',
  PaymentMethodsSetupStripe = '/paymentsMethods/setupStripe',

  // Gmail
  GmailGetCredentialsUrl = '/gmail/getCredentialsUrl',
  GmailExchangeAndSaveGmailCredentials = '/gmail/exchangeAndSaveGmailCredentials',

  // Saved Searches
  SavedSearchesGetForUser = '/savedSearches/getForUser',
  SavedSearchesSave = '/savedSearches/save',
  SavedSearchesDelete = '/savedSearches/delete',

  // Organizations
  OrganizationInviteDetails = '/organizations/getInviteDetails',
  AcceptOrganizationInvite = '/organizations/acceptInvite',
  DeclineOrganizationInvite = '/organizations/declineInvite',
  OrganizationGetUserPermissions = '/organizations/getUserPermissions',
  OrganizationGetMembersAndPermissionsV2 = '/organizations/getMembersAndPermissionsV2',

  // TermsOfService
  FetchTermsOfService = '/termsOfService/fetchTermsOfService',
  AcceptTermsOfServiceUpdates = '/termsOfService/acceptTermsOfServiceUpdates',
  TermsOfServiceAcceptanceStatus = '/termsOfService/termsOfServiceAcceptanceStatus',

  // Broker Contact Confirmation
  BrokerContactConfirmation = '/brokerContactConsent/response/new',

  // AI Dispatch
  CreateSearchAndExpireOldDispatchSearches = '/AiDispatch/dispatchUserSearch/createSearchAndExpireOldSearches',
  CreateSearchAndExpireOldDispatchSearchesForUser = '/AiDispatch/admin/dispatchUserSearch/createSearchAndExpireOldSearchesForUser',
  GetMostRecentDispatchSearch = '/AiDispatch/dispatchUserSearch/getMostRecentSearch',
  GetMostRecentDispatchSearchForUser = '/AiDispatch/admin/dispatchUserSearch/getMostRecentSearchForUser',
  GetDispatchUserLoadsBySearchIdsAndMatchLevels = '/AiDispatch/dispatchLoads/get',
  GetDispatchUserLoads = '/AiDispatch/dispatchLoads/batchGet',
  GetDispatchUserSearches = '/AiDispatch/dispatchUserSearch/get',
}

export default Endpoint;

export enum FileUploadEndpoint {
  // Carrier Verification
  CarrierVerificationAddDocuments = '/carrierVerificationDocuments/addDocuments',

  // Factoring
  FactoringInvoiceAddDocuments = '/factoringInvoices/addDocuments',
  FactoringInvoiceAddDocumentFiles = '/factoringInvoices/addDocumentFiles',

  // Broker Portal
  PostLoadsCsv = '/loads/postings/post/csv',
}
